import {HttpClient} from "../../service/httpClient/HttpClient";

export class ContactUsService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getContactUsList(page, size, fullNameFilter, phoneNumberFilter, emailFilter) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `contacts-us`,
                {
                    page: page,
                    size: size,
                    "full-name": fullNameFilter,
                    "phone-number": phoneNumberFilter,
                    "email": emailFilter,
                }
            ).then(resolve).catch(reject)
        })
    }

    getMessageInfo(messageId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `contacts-us/${messageId}`
            ).then(resolve).catch(reject)
        })
    }

    updateMessageInfo(messageId, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `contacts-us/${messageId}/status/${status}`
            ).then(resolve).catch(reject)
        })
    }

}